import React from 'react';
import { Card, Empty } from 'antd';

/**
 * 市场趋势
 * 职责：展示市场走势与趋势分析；当前为占位页，后续引入图表与数据分析。
 * 交互：暂无，后续支持时间维度与类别筛选。
 */
const MarketTrendsPage = () => {
  return (
    <div style={{ padding: '24px' }}>
      <h1>市场趋势</h1>
      <Card>
        <Empty 
          description="市场趋势功能开发中..."
          style={{ padding: '60px 0' }}
        />
      </Card>
    </div>
  );
};

export default MarketTrendsPage;
